import { Stack } from "@mui/system";
import React from "react";
import Introduction from "./Introduction";
import Section1 from "./Section1";
import FooterSection from "./FooterSection";

const PerformanceMetrics = () => {
  return (
    <Stack
      sx={{
        // border: "2px solid red",
        // height: { xl: "116vh", lg: "108vh", md: "104vh", sm: "104vh" },
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
      }}
    >
      <Stack
        sx={{
          width: { xl: "73%", lg: "89%", md: "89%", sm: "96%", xs: "" },
          gap: 2,
          height: "100%",
          // border: "2px solid red",
          paddingBottom: "80px",
        }}
      >
        <Introduction />

        <Section1 />
        {/* <Section2 /> */}
      </Stack>
    </Stack>
  );
};

export default PerformanceMetrics;
